export default __webpack_public_path__ + "static/media/logo-black.02ac0f42.svg";